import { defineTokens } from '@chakra-ui/react';

export const fontSizes = defineTokens.fontSizes({
    '2xs': { value: '0.625rem' }, // 10px
    xs: { value: '0.75rem' }, // 12px
    sm: { value: '0.875rem' }, // 14px
    md: { value: '1rem' }, // 16px
    lg: { value: '1.125rem' }, // 18px
    xl: { value: '1.25rem' }, // 20px
    '2xl': { value: '1.5rem' }, // 24px
    '3xl': { value: '1.75rem' }, // 28px
    '4xl': { value: '2.25rem' }, // 36px
    '5xl': { value: '2.5rem' }, // 40px
    '6xl': { value: '3rem' }, // 48px
    '7xl': { value: '4rem' }, // 64px
    '8xl': { value: '4.5rem' }, // 72px
});
